module.exports = __webpack_public_path__ + "img/doodles.d2973032.svg";